import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGOUT,
  CLEAR_AUTH_ERROR
} from '../constants/authConstants';
import { setAuthToken } from '../utils/setAuthToken';
import api from '../utils/api';

export const loadUser = () => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_LOADING });

    const token = getState().auth.token;
    
    if (!token) {
      return dispatch({ type: AUTH_ERROR });
    }

    setAuthToken(token);
    
    const res = await api.get('/users/me');
    
    dispatch({
      type: USER_LOADED,
      payload: res.data
    });
  } catch (error) {
    localStorage.removeItem('token');
    dispatch({ type: AUTH_ERROR });
  }
};

export const register = (userData) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await api.post(
      '/auth/register',
      userData,
      config
    );

    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: res.data
    });

    localStorage.setItem('token', res.data.token);
    setAuthToken(res.data.token);
    
    dispatch(loadUser());
    
    return true;
  } catch (error) {
    const errorMessage = 
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    
    dispatch({
      type: USER_REGISTER_FAIL,
      payload: errorMessage
    });
    
    return false;
  }
};

export const login = (phoneNumber, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await api.post(
      '/auth/login',
      { phone_number: phoneNumber, password },
      config
    );

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: res.data
    });

    localStorage.setItem('token', res.data.token);
    setAuthToken(res.data.token);
    
    dispatch(loadUser());
    
    return true;
  } catch (error) {
    const errorMessage = 
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: errorMessage
    });
    
    return false;
  }
};

// Reset password with verification code
export const resetPassword = (phoneNumber, code, newPassword) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await api.post(
      '/auth/reset-password',
      { phone_number: phoneNumber, code, new_password: newPassword },
      config
    );

    return { success: true, message: res.data.message };
  } catch (error) {
    const errorMessage = 
      error.response && error.response.data.message
        ? error.response.data.message
        : 'Password reset failed';
    
    return { success: false, message: errorMessage };
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('token');
  dispatch({ type: LOGOUT });
};